const productSections = new WeakMap();
const productMediaPlayback = new WeakMap();

const pauseProductMedia = (section, exceptMediaId = null) => {
  section.querySelectorAll('.product__media-container [data-media-id]').forEach((media) => {
    if (exceptMediaId && media.dataset.mediaId === exceptMediaId) return;

    media.querySelectorAll('video').forEach((video) => video.pause());
    media.querySelectorAll('iframe').forEach((frame) => {
      const src = frame.getAttribute('src') || '';
      const command = src.includes('youtube.com') || src.includes('youtu.be')
        ? { event: 'command', func: 'pauseVideo', args: [] }
        : src.includes('vimeo.com')
          ? { method: 'pause' }
          : null;

      if (command) frame.contentWindow?.postMessage(JSON.stringify(command), '*');
    });
  });
};

const initProductMediaPlayback = (section) => {
  if (productMediaPlayback.has(section)) return;

  const onThumbnailClick = (event) => {
    const thumbnail = event.target?.closest?.('[data-product-thumbnail]');
    if (!thumbnail || !section.contains(thumbnail)) return;
    pauseProductMedia(section, thumbnail.dataset.thumbnailId);
  };

  const cleanup = () => {
    pauseProductMedia(section);
    document.removeEventListener('click', onThumbnailClick, true);
  };

  document.addEventListener('click', onThumbnailClick, true);
  productMediaPlayback.set(section, cleanup);
};

const initDependentOptions = (section) => {
  if (productSections.has(section)) return;

  const picker = section.querySelector('[data-hide-unavailable-dependent-options="true"]');
  if (!picker || picker.dataset.enableDynamicProductOptions === 'false') return;

  const variantsNode = picker.querySelector('[data-variant-json]');
  if (!variantsNode) return;
  const variants = JSON.parse(variantsNode.textContent);
  const inputs = Array.from(picker.querySelectorAll('.dynamic-variant-input'));

  const sync = () => {
    inputs.forEach((input, index) => {
      const matching = variants.filter((variant) => inputs.slice(0, index).every((parent, parentIndex) => (
        variant.options[parentIndex] === parent.value
      )));
      const values = new Set(matching.map((variant) => variant.options[index]));
      if (values.size && !values.has(input.value)) {
        const option = Array.from(input.options).find((candidate) => values.has(candidate.value));
        if (option) {
          input.value = option.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const group = Array.from(picker.querySelectorAll('.dynamic-variant-input-wrap')).find((node) => (
        node.dataset.index === input.dataset.index
      ));
      group?.querySelectorAll('.dynamic-variant-button').forEach((button) => {
        button.hidden = !values.has(button.dataset.optionValue);
        button.classList.toggle('selected', button.dataset.optionValue === input.value);
      });
    });
  };

  const onChange = (event) => {
    if (inputs.includes(event.target)) sync();
  };
  picker.addEventListener('change', onChange, true);
  productSections.set(section, () => picker.removeEventListener('change', onChange, true));
  sync();
};

const init = (root) => {
  const sections = [];
  if (root.matches?.('[data-section-type="product"]')) sections.push(root);
  sections.push(...root.querySelectorAll('[data-section-type="product"]'));
  sections.forEach((section) => {
    initDependentOptions(section);
    initProductMediaPlayback(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
} else {
  init(document);
}

document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  const unload = (section) => {
    productSections.get(section)?.();
    productSections.delete(section);
    productMediaPlayback.get(section)?.();
    productMediaPlayback.delete(section);
  };
  if (event.target.matches('[data-section-type="product"]')) unload(event.target);
  event.target.querySelectorAll('[data-section-type="product"]').forEach(unload);
});
